import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DictionaryType, DocumentStatus } from './domain/dictionary.model';
import { ForgotPasswordComponent } from './modules/core/components/forgot-password/forgot-password.component';
import { FrontierSummaryComponent } from './modules/core/components/frontier-summary/frontier-summary.component';
import { FrontierSummaryResolver } from './modules/core/components/frontier-summary/frontier-summary.resolver';
import { DescriptionComponent } from './modules/core/components/ioffer/description/description.component';
import { IofferMainComponent } from './modules/core/components/ioffer/ioffer-main.component';
import { IOfferComponent } from './modules/core/components/ioffer/ioffer/ioffer.component';
import { IOfferResolver } from './modules/core/components/ioffer/ioffer/ioffer.resolver';
import { IPolicyComponent } from './modules/core/components/ioffer/ipolicy/ipolicy.component';
import { IPolicyGuard } from './modules/core/components/ioffer/ipolicy/ipolicy.guard';
import { IstyleguideComponent } from './modules/core/components/ioffer/istyleguide/istyleguide.component';
import { IVerificationComponent } from './modules/core/components/ioffer/iverification/iverification.component';
import { IVerificationGuard } from './modules/core/components/ioffer/iverification/iverification.guard';
import { ReturnComponent } from './modules/core/components/ioffer/return/return.component';
import { LanguageComponent } from './modules/core/components/language/language.component';
import { LoginComponent } from './modules/core/components/login/login.component';
import { MainComponent } from './modules/core/components/main/main.component';
import { EditFrontierComponent } from './modules/core/components/new-frontier/edit-frontier.component';
import { EditFrontierResolver } from './modules/core/components/new-frontier/edit-frontier.resolver';
import { NewFrontierComponent } from './modules/core/components/new-frontier/new-frontier.component';
import { NewFrontierResolver } from './modules/core/components/new-frontier/new-frontier.resolver';
import { NewOfferComponent } from './modules/core/components/new-offer/new-offer.component';
import { CalculationCardComponent } from './modules/core/components/offer/calculation-card/calculation-card.component';
import { CalculationSummaryComponent } from './modules/core/components/offer/calculation-summary/calculation-summary.component';
import { OfferCardComponent } from './modules/core/components/offer/offer-card/offer-card.component';
import { OfferComponent } from './modules/core/components/offer/offer.component';
import { OfferResolver } from './modules/core/components/offer/offer.resolver';
import { PasswordResetComponent } from './modules/core/components/password-reset/password-reset.component';
import { PolicyCardComponent } from './modules/core/components/policy-card/policy-card.component';
import { PolicyResolver } from './modules/core/components/policy-card/policy.resolver';
import { RegistryCleanResolver } from './modules/core/components/registry/registry-clean.resolver';
import { RegistryComponent } from './modules/core/components/registry/registry.component';
import { SalespointComponent } from './modules/core/components/salespoint/salespoint.component';
import { StyleguideComponent } from './modules/core/components/styleguide/styleguide.component';
import { TimetableComponent } from './modules/core/components/timetable/timetable.component';
import { TimetableResolver } from './modules/core/components/timetable/timetable.resolver';
import { DevelopmentGuard } from './modules/core/guard/development.guard';
import { FrontierGuard } from './modules/core/guard/frontier.guard';
import { UserGuard } from './modules/core/guard/user.guard';
import { DictionaryResolver } from './modules/core/resolver/dictionary.resolver';
import { ScheduleFlagResolver } from './modules/core/resolver/schedule-flag.resolver';


const routes: Routes = [
    {
        path: 'styleguide',
        component: StyleguideComponent,
        canActivate: [DevelopmentGuard],
    },
    {
        path: 'language/:language',
        component: LanguageComponent,
    },
    {
        path: 'ioffer',
        component: IofferMainComponent,
        children: [
            {
                path: 'verification/:token',
                component: IVerificationComponent,
                canActivate: [IVerificationGuard]
            },
            {
                path: 'offer',
                component: IOfferComponent,
                resolve: {
                    resolver: IOfferResolver,
                }
            },
            {
                path: 'policy',
                component: IPolicyComponent,
                canActivate: [IPolicyGuard],
            },

            {
                path: 'expired',
                component: DescriptionComponent,
                data: {
                    icon: 'icon-danger mt-56 icon-red-lg d-block',
                    header: 'IOFFER.EXPIRED.TITLE',
                    title: 'IOFFER.EXPIRED.SUB_TITLE',
                    description: 'IOFFER.EXPIRED.SUB_TITLE2',
                }
            },
            {
                path: 'no-state',
                component: DescriptionComponent,
                data: {
                    icon: 'icon-danger mt-160 icon-red-lg d-block',
                    header: 'IOFFER.BROKEN_LINK.TITLE',
                    title: 'IOFFER.BROKEN_LINK.SUB_TITLE',
                    description: 'IOFFER.BROKEN_LINK.SUB_TITLE2',
                }
            },
            {
                path: 'rejected',
                component: DescriptionComponent,
                data: {
                    icon: 'icon-warning mt-56 icon-red-lg d-block',
                    header: 'IOFFER.REJECTED.TITLE',
                    title: 'IOFFER.REJECTED.SUB_TITLE',
                    description: '',
                }
            },
            {
                path: 'return/:orderId',
                component: ReturnComponent,
                data: {
                    icon: '',
                    header: 'IOFFER.RETURN.TITLE',
                    title: 'IOFFER.RETURN.SUB_TITLE',
                    description: '',
                }
            },
            {
                path: 'styleguide',
                component: IstyleguideComponent,
                canActivate: [DevelopmentGuard],
            },
            {
                path: '',
                redirectTo: 'verification',
                pathMatch: 'full'
            },
        ]
    },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
    },
    {
        path: 'password-reset/:token',
        component: PasswordResetComponent,
    },
    {
        path: '',
        component: SalespointComponent,
        canActivate: [UserGuard],
        data: {
            dictionaries: [
                DictionaryType.DOCUMENT_TYPE,
                DictionaryType.GENDER,
                DictionaryType.NATIONALITY,
                DictionaryType.LOCALITY_TYPE,
                DictionaryType.PROPERTY_TYPE,
                DictionaryType.CALCULATION_SUBJECT,
                DictionaryType.FLOOD_CLAIMS,
                DictionaryType.NUMBER_OF_INSURED,
                DictionaryType.INSTALLMENTS,
                DictionaryType.DEFERRED_PAYMENT,
                DictionaryType.VEHICLE_UNUSUAL_USAGE,
                DictionaryType.VEHICLE_BODY_TYPE,
                DictionaryType.VEHICLE_TYPE,
                DictionaryType.VEHICLE_FUEL_TYPE,
                DictionaryType.VEHICLE_DOORS,
                DictionaryType.CLAIM_SETTLEMENT_MODE,
            ]
        },
        resolve: {
            dictionaries: DictionaryResolver,
        },
        children: [
            {
                path: 'main',
                component: MainComponent,
                resolve: {
                    scheduleFlag: ScheduleFlagResolver,
                }
            },
            {
                path: 'new-offer',
                component: NewOfferComponent,
                resolve: {
                    scheduleFlag: ScheduleFlagResolver,
                }
            },
            {
                path: 'new-frontier',
                component: NewFrontierComponent,
                canActivate: [FrontierGuard],
                data: {
                    dictionaries: [
                        DictionaryType.COUNTRY,
                        DictionaryType.INSURANCE_PERIOD,
                        DictionaryType.FRONTIER_VEHICLE_CATEGORY,
                        DictionaryType.PARTY_TYPE,
                        DictionaryType.PAYMENT_TYPE,
                    ]
                },
                resolve: [
                    DictionaryResolver,
                    NewFrontierResolver,
                ],
            },
            {
                path: 'frontier/:id/card',
                component: EditFrontierComponent,
                canActivate: [FrontierGuard],
                data: {
                    dictionaries: [
                        DictionaryType.COUNTRY,
                        DictionaryType.INSURANCE_PERIOD,
                        DictionaryType.FRONTIER_VEHICLE_CATEGORY,
                        DictionaryType.PARTY_TYPE,
                        DictionaryType.PAYMENT_TYPE,
                    ]
                },
                resolve: [
                    DictionaryResolver,
                    EditFrontierResolver,
                ],
            },
            {
                path: 'frontier/:id/summary',
                component: FrontierSummaryComponent,
                canActivate: [FrontierGuard],
                resolve: {
                    resolver: FrontierSummaryResolver,
                }
            },
            {
                path: 'timetable',
                component: TimetableComponent,
                resolve: {
                    resolver: TimetableResolver,
                }
            },
            {
                path: 'policy/:id',
                component: PolicyCardComponent,
                resolve: {
                    resolver: PolicyResolver,
                }
            },
            {
                path: 'calculation/:id',
                component: OfferComponent,
                children: [
                    {
                        path: 'card',
                        component: CalculationCardComponent,
                        data: {
                            statuses: [DocumentStatus.CALCULATION],
                        },
                        resolve: {
                            resolver: OfferResolver,
                            scheduleFlag: ScheduleFlagResolver,
                        },
                    },
                    {
                        path: 'summary',
                        component: CalculationSummaryComponent,
                        data: {
                            statuses: [DocumentStatus.CALCULATION],
                            dictionaries: [
                                DictionaryType.CESSION_PARTY_TYPE,
                            ]
                        },
                        resolve: {
                            dictionaries: DictionaryResolver,
                            scheduleFlag: ScheduleFlagResolver,
                            resolver: OfferResolver,
                        },
                    },
                    {
                        path: 'offer',
                        component: OfferCardComponent,
                        data: {
                            statuses: [DocumentStatus.OFFER, DocumentStatus.IOFFER, DocumentStatus.CANCELLED],
                        },
                        resolve: {
                            resolver: OfferResolver,
                            scheduleFlag: ScheduleFlagResolver,
                        },
                    }
                ]
            },
            {
                path: 'registry',
                pathMatch: 'full',
                redirectTo: '/registry/offer?clear=true'
            },
            {
                path: 'registry/:type',
                component: RegistryComponent,
                data: {
                    dictionaries: [
                        DictionaryType.OFFER_STATUS,
                    ]
                },
                resolve: {
                    clean: RegistryCleanResolver,
                    dictionaries: DictionaryResolver,
                },
            },
            {
                path: '**',
                redirectTo: '/main',
            },
        ]
    }
];


@NgModule({
    imports: [
        RouterModule.forRoot(routes),
    ],
    exports: [
        RouterModule,
    ],
    providers: [
        UserGuard,
        FrontierGuard,
        DevelopmentGuard,
        IVerificationGuard,
        IPolicyGuard,

        DictionaryResolver,
        OfferResolver,
        RegistryCleanResolver,
        PolicyResolver,
        TimetableResolver,
        ScheduleFlagResolver,
        IOfferResolver,
        NewFrontierResolver,
        FrontierSummaryResolver,
        EditFrontierResolver,
    ]
})
export class AppRoutingModule {
}
